import React, { useState, useEffect } from "react";
import DataTable from 'react-data-table-component';
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';
import parse from 'html-react-parser';

import { api_crud_route, /*api_crud_base,*/ endpoints } from './Config';

import { reqGET, reqPUT, reqDELETE } from '../../Utils';
import { getTokenInfo } from '../../UseToken';
import UseSidebar from '../../UseSidebar';

import Loader from '../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {

    const [data, setData] = useState([])
    const [, setData_2] = useState([])
    const [isloading, setLoading] = useState(true)

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})

    const [refresh, setRefresh] = useState(0)

    /*const order_menu = (parent, array, array2) => {
        let array_aux = array.filter(v => v.info.parent === parent)
        array_aux.forEach(v => {
            array2.push(v)
            order_menu(v.id, array, array2)
		})
	}*/

    let today_date = new Date()
    const [today, /*_*/] = useState(today_date.getFullYear() + '-' + (today_date.getMonth() + 1).toString().padStart(2, '0') + '-' + today_date.getDate().toString().padStart(2, '0'))

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    let fetchApi = async () => {
        set_lang(localStorage.getItem('lang'))

        return await reqGET(`${api_crud_route}/parent/${getTokenInfo().companycode}/${getTokenInfo().id}`)

            .then(res => {
                let array_aux = []
                //order_menu('0', res.data, array_aux)
                //setData(array_aux)
                setData(res.data)

                setData_2(array_aux)
                setLoading(false)
            })
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //alert(error)); 
            )
    }

    useEffect(() => {
        fetchApi()  
        
        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                setLoading(false)
            }); 
    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})

    }

    const columns = [
        {
            name: language[lang].table_title,
            selector: 'title',
            cell: row => <div>{row.content[0].name}</div>,
            width: '50%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].table_date,
            selector: 'info.date.creation',
            cell: row => {
                //let hoje = new Date();
                let date = new Date(row.info.date.creation); 
                
                /*let status = 0
                if(row.info.date.published !== undefined && row.info.date.published !== '') {
                    var date_p = new Date(row.info.date.published);

                    status = 1
                    if(hoje >= date_p) 
                        status = 2
                }*/
                
                return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].table_state,
            selector: 'title',
            cell: row => {
                /*let hoje = new Date();
                let date = new Date(row.info.date.creation); 
                
                let status = 0
                if(row.info.date.published !== undefined && row.info.date.published !== '') {
                    var date_p = new Date(row.info.date.published);

                    status = 1
                    if(hoje >= date_p) 
                        status = 2
                }*/
                
                return (
                    <span className={row.info.status === 'accepted' ? "badge rounded-pill fw-normal bg-success" : (row.info.status === 'rejected' ? "badge rounded-pill fw-normal bg-danger" : "badge rounded-pill fw-normal bg-light")}>
                        {row.info.status === 'accepted' ? language[lang].accepted : row.info.status === 'rejected' ? language[lang].rejected : language[lang].under_review}
                    </span>
                )
            },
            width: '10%',
            minWidth: '82px !important',
            sortable: true,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '100px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                    permissions.edit ?
                        <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} style={{ display: '' }} replace>
                            <i className="bi bi-pencil"></i>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.remove ?
                        <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(row['id'])}>
                            <i className="bi bi-trash"></i>
                        </button>
                    :
                        null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const seeNotification = (id) => {
        let element = {}
        data.forEach(el => {
            if(el.id === id) {
                el.info.notified = true
                element = el

                reqPUT(api_crud_route, element)
                    .then(() => { 
                        //props.history.push(endpoints.list) 

                        //Swal.fire(language[lang].edit_success, '', 'info')
                        setRefresh(refresh + 1)
                    })
                    .catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
            }
        })

    }

    return (isloading ?
        
        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].content_list}</h2>
                <p>{language[lang].content} / {language[lang].content_list}</p>
            </div>
        
            <div id="notes">
                <div className="container mb-5">

                    <div className="div-table">
                        <div className="table-header text-end my-5">
                            <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                <img className="me-2" alt={language[lang].add_new} title={language[lang].add_new} src={'./img/plus.svg'} />
                                <span>{language[lang].add_new}</span>
                            </Link>
                        </div>

                        <div className="row">
                            {/*console.log('ELEMENT', data)*/}
                            {
                            data.map((element, key) => {
                                /*{/*console.log('ELEMENT', element)}*/
                                /*var hoje = new Date();
                                var date = new Date(element.info.date.creation); 
                                
                                let status = 0
                                if(element.info.date.published !== undefined && element.info.date.published !== '') {
                                    var date_p = new Date(element.info.date.published);

                                    status = 1
                                    if(hoje >= date_p) 
                                        status = 2
                                }*/
                                
                                return(
                                    element.content.map((v, key2) => {
                                        return(
                                            
                                            <div className="col-4" key={key2}>
                                                <div className="card">
                                                    <div className="mt-3">
                                                        <button 
                                                            className={"button button-update button-view float-right" + (element.info.date['notification'] !== undefined ? (element.info.date['notification'] === today ? (element.info.notified !== undefined && element.info.notified === true ? ' d-none' : '') : ' d-none') : ' d-none' )}
                                                            onClick={() => seeNotification(element.id)}
                                                        >
                                                            <i className="bi bi-bell bg-danger me-2"></i>
                                                        </button>
                                                    </div>
                                                    <div className="card-body">
                                                        <span className="card-text webkit-line-clamp-10">
                                                            {parse(v.message)}
                                                        </span>
                                                        <div className="card-text mt-5">
                                                            <small className="text-muted float-left">{element.info.date.creation.split('T')[0]}</small>
                                                        
                                                            <div className="float-right">
                                                                
                                                                <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: element, operation: 'view' } }} replace>
                                                                    <i className="bi bi-eye"></i>
                                                                </Link>

                                                                {
                                                                permissions.edit ?
                                                                    <Link className={permissions.edit ? "button button-update position-relative" : "d-none" } to={{ pathname: endpoints.regist, state: { item: element, operation: 'edit' } }} replace>
                                                                        <i className="bi bi-pencil red me-2"></i>
                                                                        <span className="tooltiptext">{language[lang].edit}</span>
                                                                    </Link>
                                                                :
                                                                    null
                                                                }

                                                                {
                                                                <button className={permissions.remove ? "button button-delete position-relative" : "d-none" } onClick={() => apagar(element.id)} >
                                                                    <i className="bi bi-trash gray"></i>
                                                                    <span className="tooltiptext">{language[lang].delete}</span>
                                                                </button>
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>  
                                            </div>
                                        )
                                    })
                                )
                            }) 
                            }	
                        </div>

                        <div className="table-body d-none">                                        
                            <DataTable
                                columns={columns}
                                data={data}
                                noDataComponent={language[lang].table_empty}
                                noHeader
                                pagination
                                exportHeaders
                                paginationComponentOptions={defaultComponentOptions}
                                paginationPerPage={25}
                                paginationRowsPerPageOptions={[25, 50, 100]}
                            />
                        </div>
                    </div>

                    <div className="card mb-5 mb-xl-8 d-none">
                        <div className="card-body">
                            <div className="pb-5 ">
                                <div className="div-table">
                                    <div className="table-body">

										<table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_table_users">
											<thead>
												<tr className="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
													<th className="min-w-250px">{language[lang].table_name}</th>
													<th className="min-w-125px d-none">{language[lang].table_parent}</th>
													<th className="text-center min-w-125px">{language[lang].table_date}</th>
													<th className="text-center min-w-100px">{language[lang].table_state}</th>
													<th className="text-end min-w-100px">{language[lang].table_actions}</th>
												</tr>
											</thead>
											<tbody className="text-gray-600 fw-bold">
                                                {
                                                data.map((element, key) => {
                                                    //var hoje = new Date();
                                                    var date = new Date(element.info.date.creation); 
                                                    
                                                   /*let status = 0
                                                    if(element.info.date.published !== undefined && element.info.date.published !== '') {
                                                        var date_p = new Date(element.info.date.published);

                                                        status = 1
                                                        if(hoje >= date_p) 
                                                            status = 2
                                                    }*/

                                                    return(
                                                        <tr key={key}>
                                                            
                                                            <td>{element.content[0].name}</td>
                                                            <td className="d-none">{element.info.parent}</td>
                                                            <td className="text-center">{date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()}</td>
                                                            <td className="text-center">
                                                                <span className={element.info.status === 'accepted' ? "badge rounded-pill bg-success" : (element.info.status === 'rejected' ? "badge rounded-pill bg-danger" : "badge rounded-pill bg-light")}>
                                                                    {element.info.status === 'accepted' ? language[lang].accepted : element.info.status === 'rejected' ? language[lang].rejected : language[lang].under_review}
                                                                </span>
                                                            </td>
                                                            <td className="text-end">

                                                                <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: element, operation: 'view' } }} replace>
                                                                    <i className="bi bi-eye"></i>
                                                                </Link>

                                                                {
                                                                permissions.edit ?
                                                                    <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: element, operation: 'edit' } }} replace>
                                                                        <i className="bi bi-pencil"></i>
                                                                    </Link>
                                                                :
                                                                    null
                                                                }

                                                                {
                                                                permissions.remove ?
                                                                    <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(element.id)} >
                                                                        <i className="bi bi-trash"></i>
                                                                    </button>
                                                                :
                                                                    null
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                }) 
                                                }												
											</tbody>
										</table>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}